import React from 'react'
import { PrescImage } from '../../../types/models/PrescImage'
import { ImageArea } from '../../../types/models/Presc'
import { usePrescriptionImageBox } from '../../../features/prescription'
import { AnnotatablePrescriptionImageBox } from '../components/AnnotatablePrescriptionImageBox'
import { AnnotationBox } from '../components/NumberAnnotationPanel'

export const useAnnotatablePrescriptionImageBox = (
  prescriptionImages: PrescImage[],
  imageArea: ImageArea[],
  isAnnotationMode: boolean,
  selectedField: string,
  annotations: AnnotationBox[],
  onAnnotationAdd: (annotation: AnnotationBox) => void,
  fieldColors: Record<string, string>
) => {
  const baseHookResult = usePrescriptionImageBox(prescriptionImages, imageArea)

  // Extract the original PrescImageBox component
  const originalPrescImageBox = baseHookResult.PrescImageBox

  // Create annotatable version if we have the original component
  const AnnotatablePrescImageBox = originalPrescImageBox && (
    <AnnotatablePrescriptionImageBox
      {...originalPrescImageBox.props}
      isAnnotationMode={isAnnotationMode}
      selectedField={selectedField}
      annotations={annotations}
      onAnnotationAdd={onAnnotationAdd}
      fieldColors={fieldColors}
    />
  )

  return {
    ...baseHookResult,
    PrescImageBox: AnnotatablePrescImageBox,
  }
}
